import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AtiraEmptyWithAction } from '../../../components/AtiraEmptyWithAction';
import { Flex } from '../../../components/Flex';
import { EditAtiraLinkDto } from '../../../model/atira-link/dto/EditAtiraLinkDto';
import { atiraLinkSliceSelectors } from '../../../redux/atira-link/atira-link.selector';
import { useAppSelector } from '../../../redux/store';
import { SettingsGoogleAnalytics } from '../components/SettingsGoogleAnalytics';
import { SettingsMetaAnalytics } from '../components/SettingsMetaAnalytics';

export const SettingsCustomAnalytics: React.FC = () => {
  const { t } = useTranslation();

  const formMethods = useForm<EditAtiraLinkDto>();

  const navigate = useNavigate();

  const userAtiraLinks = useAppSelector(
    atiraLinkSliceSelectors.selectUserAtiraLinks,
  );

  if (!userAtiraLinks.length) {
    return (
      <AtiraEmptyWithAction
        description={t('settings.no_link')}
        buttonTitle={t('common.create_link')}
        onClick={() => navigate('/my-link')}
      />
    );
  }

  return (
    <FormProvider {...formMethods}>
      <Flex flexDirection="column" width={'100%'} gap="m">
        <SettingsGoogleAnalytics />
        <SettingsMetaAnalytics />
      </Flex>
    </FormProvider>
  );
};
